<ng-container *transloco="let t">

  <div *ngIf="mobileLayout" class="pb-4">
    <qm-sidebar [(displaySidebar)]="display" logoPath="assets/img/logo-claro.png" [itemsMenu]="items"/>
    <div class="mobileHeaderContainer">
      <div class="col-2 flex justify-content-center align-items-center">
        <qm-button [onlyIcon]="true" [shadow]="true" buttonIconAction="menu" (clickEvent)="display = true"/>
      </div>
      
      <div class="col-8 flex justify-content-center align-items-center">
        <qm-autocomplete [inputSuggestions]="listaSuggestions" [ignoreOptional]=true
        (searchEvent)="onSearchData($event)" style="width: 100%"
        (selectEvent)="onSelectData($event)" [(ngModel)]="moduleValue"
        placeholderMessage="{{ t('header-search-placeholder') }}"></qm-autocomplete>
      </div>
      
      <div class="col-2 flex justify-content-center align-items-center">
      <qm-button [onlyIcon]="true" [shadow]="true" (clickEvent)="logout()"  buttonIconAction="logout"></qm-button>
    </div>
  </div>
  </div>

  <div *ngIf="!mobileLayout" class="grid pb-2">

    <div class="col-2 flex justify-content-center align-items-center">
      <a routerLink="/home">
          <img src="assets/img/logo-claro.png" height="55" class="mr-3 ml-2">
      </a>
    </div>

    <div class="col-2 flex justify-content-center align-items-center">
      <qm-menubar [itemsMenu]="items" />
    </div>

    <div class="col-4 flex justify-content-center align-items-center">
      <qm-autocomplete [inputSuggestions]="listaSuggestions" [ignoreOptional]=true
      (searchEvent)="onSearchData($event)" style="width: 100%"
      (selectEvent)="onSelectData($event)" [(ngModel)]="moduleValue"
      placeholderMessage="{{ t('header-search-placeholder') }}"></qm-autocomplete>
    </div>

    <div class="col-3 flex justify-content-center align-items-center">
      <qm-label labelMessage="{{ t('header-version') }} {{versionApp}}" sizeFont="small"></qm-label>
    </div>

    <div class="col-1 flex justify-content-center align-items-center">
        <qm-button (clickEvent)="logout()" labelMessage="{{ t('header-logout') }}" buttonIconAction="logout"></qm-button>
    </div>

  </div>

</ng-container>
